// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as RR from "common/src/RR.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as TC from "common/src/components/TC.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as Colors from "common/src/Colors.bs.js";
import * as Data46 from "common/src/data/Data46.bs.js";
import * as TbDefs from "../team-planner-core/TbDefs.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as TbAtoms from "../team-planner-core/TbAtoms.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as TbConsts from "../team-planner-core/TbConsts.bs.js";
import * as TbUtils46 from "./TbUtils46.bs.js";
import * as ReactDnd from "react-dnd";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TbBranding from "../team-planner-core/TbBranding.bs.js";
import * as TbConfig46 from "./TbConfig46.bs.js";
import * as TbItemCell from "../team-planner-core/TbItemCell.bs.js";
import * as Belt_MapInt from "rescript/lib/es6/belt_MapInt.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as LocalStorage from "common/src/LocalStorage.bs.js";
import * as TbTraitsList from "../team-planner-core/TbTraitsList.bs.js";
import * as DragPreview46 from "./DragPreview46.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as SnackbarService from "common/src/SnackbarService.bs.js";
import * as TbUnitSelection from "../team-planner-core/TbUnitSelection.bs.js";
import * as TbTeamsSeparator from "../team-planner-core/TbTeamsSeparator.bs.js";
import * as TeamPlannerHex46 from "./TeamPlannerHex46.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as TbRadiantItemsGrid from "../team-planner-core/TbRadiantItemsGrid.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as TbTraitsListCompact from "../team-planner-core/TbTraitsListCompact.bs.js";
import * as TbAugmentSelection46 from "./TbAugmentSelection46.bs.js";
import * as TbCraftableItemsGrid from "../team-planner-core/TbCraftableItemsGrid.bs.js";
import * as TbComponentsSection46 from "./TbComponentsSection46.bs.js";

function TbPage46$ItemsGrid(Props) {
  var search = Props.search;
  var choiceTab = Props.choiceTab;
  var t = Translation.useT(/* Common */0);
  Translation.useT(/* Traits */2);
  var itemsT = Translation.useT(/* Items */3);
  var match = React.useState(function () {
        return /* Craftable */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var emblemIds = Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keep(Js_dict.entries(Data46.items), (function (param) {
                  if (param[1].tags.includes("ElusiveEmblem")) {
                    return !Data46.panEmblems.includes(param[0]);
                  } else {
                    return false;
                  }
                })), (function (prim) {
              return prim[0];
            })), (function (id1, id2) {
          return Caml.caml_string_compare(itemsT(id1), itemsT(id2));
        }));
  var ornnIds = Belt_SortArray.stableSortBy(React.useMemo((function () {
              return Belt_Array.keep(Belt_Array.map(Belt_Array.keepU(Js_dict.entries(Data46.items), (function (param) {
                                    return param[1].tags.includes("Artifact");
                                  })), (function (prim) {
                                return prim[0];
                              })), (function (id) {
                            if (id.endsWith("DU")) {
                              return false;
                            } else {
                              return !id.endsWith("HR");
                            }
                          }));
            }), []), (function (id1, id2) {
          return Caml.caml_string_compare(itemsT(id1), itemsT(id2));
        }));
  var supportIds = Belt_SortArray.stableSortBy(React.useMemo((function () {
              return Belt_Array.keep(Belt_Array.map(Belt_Array.keepU(Js_dict.entries(Data46.items), (function (param) {
                                    return param[1].tags.includes("Support");
                                  })), (function (prim) {
                                return prim[0];
                              })), (function (id) {
                            if (id.endsWith("DU")) {
                              return false;
                            } else {
                              return !id.endsWith("HR");
                            }
                          }));
            }), []), (function (id1, id2) {
          return Caml.caml_string_compare(itemsT(id1), itemsT(id2));
        }));
  React.useMemo((function () {
          return Belt_Array.keep(Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.keepU(Js_dict.entries(Data46.items), (function (param) {
                                    return param[1].tags.includes("Other");
                                  })), (function (param, param$1) {
                                return Caml.caml_int_compare(param[1].id, param$1[1].id);
                              })), (function (prim) {
                            return prim[0];
                          })), (function (id) {
                        return id.includes("Faerie");
                      }));
        }), []);
  var tmp;
  switch (tab) {
    case /* Craftable */0 :
        tmp = React.createElement(TbCraftableItemsGrid.make, {
              search: search
            });
        break;
    case /* Radiant */1 :
        tmp = React.createElement(TbRadiantItemsGrid.make, {
              search: search
            });
        break;
    case /* Other */2 :
        tmp = React.createElement("div", {
              className: "flex flex-col items-center gap-4"
            }, React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", {
                      className: "text-base font-montserrat font-medium flex-shrink-0 w-[88px]"
                    }, t("Elusive Emblems")), React.createElement("div", {
                      className: "flex flex-wrap border-l w-[202px]"
                    }, Belt_Array.mapWithIndex(emblemIds, (function (idx, itemId) {
                            return React.createElement("div", {
                                        key: itemId,
                                        className: "border-b border-r" + (
                                          idx < 6 ? " border-t" : ""
                                        )
                                      }, React.createElement(TbItemCell.make, {
                                            search: search,
                                            itemId: itemId,
                                            key: itemId
                                          }));
                          })))), React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", {
                      className: "text-base font-montserrat font-medium flex-shrink-0 w-[88px]"
                    }, t("Artifacts")), React.createElement("div", {
                      className: "flex flex-wrap border-l w-[202px]"
                    }, Belt_Array.mapWithIndex(ornnIds, (function (idx, itemId) {
                            return React.createElement("div", {
                                        key: itemId,
                                        className: "border-b border-r" + (
                                          idx < 6 ? " border-t" : ""
                                        )
                                      }, React.createElement(TbItemCell.make, {
                                            search: search,
                                            itemId: itemId,
                                            key: itemId
                                          }));
                          })))), React.createElement("div", {
                  className: "flex items-center"
                }, React.createElement("div", {
                      className: "text-base font-montserrat font-medium flex-shrink-0 w-[88px]"
                    }, t("Support Items")), React.createElement("div", {
                      className: "flex flex-wrap border-l w-[202px]"
                    }, Belt_Array.mapWithIndex(supportIds, (function (idx, itemId) {
                            return React.createElement("div", {
                                        key: itemId,
                                        className: "border-b border-r" + (
                                          idx < 6 ? " border-t" : ""
                                        )
                                      }, React.createElement(TbItemCell.make, {
                                            search: search,
                                            itemId: itemId,
                                            key: itemId
                                          }));
                          })))));
        break;
    
  }
  return React.createElement(ContentSection.make, {
              className: (
                choiceTab === "Items" ? "" : "hidden"
              ) + " md:block md:ml-6 p-3 pt-0 sm:p-[14px] sm:pt-0 sm:w-[326px]",
              children: React.createElement("div", {
                    className: "select-none flex flex-col items-center"
                  }, React.createElement(Tabs, {
                        classes: {
                          root: "mb-4"
                        },
                        children: null,
                        value: tab,
                        onChange: (function (param, t) {
                            return Curry._1(setTab, (function (param) {
                                          return t;
                                        }));
                          })
                      }, React.createElement(Tab, {
                            label: t("Craftable"),
                            value: /* Craftable */0
                          }), React.createElement(Tab, {
                            label: t("Radiant"),
                            value: /* Radiant */1
                          }), React.createElement(Tab, {
                            label: t("Other"),
                            value: /* Other */2
                          })), tmp)
            });
}

var make = React.memo(TbPage46$ItemsGrid);

var ItemsGrid = {
  make: make
};

function TbPage46$TraitsListWrap(Props) {
  var setHighlightTrait = Props.setHighlightTrait;
  var units = Props.units;
  var traitCounts = Props.traitCounts;
  var onFilterTrait = Props.onFilterTrait;
  var chosenTrait = Props.chosenTrait;
  var exaltedUnits = Props.exaltedUnits;
  var tmp = {
    setHighlightTrait: setHighlightTrait,
    units: units,
    traitCounts: traitCounts,
    onFilterTrait: onFilterTrait,
    exaltedUnits: exaltedUnits
  };
  if (chosenTrait !== undefined) {
    tmp.chosenTrait = Caml_option.valFromOption(chosenTrait);
  }
  return React.createElement(TbTraitsList.make, tmp);
}

var TraitsListWrap = {
  make: TbPage46$TraitsListWrap
};

function hexesToTitle(hexes, augments) {
  var match = TbUtils46.getData(hexes, false, augments, []);
  return TC.getCoreTraitsStr(true, Belt_Array.map(match[1], (function (param) {
                    var traitId = param[0];
                    var rank = Sd.traitRank(traitId, param[1], 46);
                    return [
                            traitId,
                            rank
                          ];
                  })), 46);
}

function qsToTitle(qs) {
  var match = TbUtils46.decodeQs(qs);
  return hexesToTitle(match[0], match[1]);
}

function TbPage46$UnitItemSelection(Props) {
  var addUnit = Props.addUnit;
  var search = Props.search;
  var setSearch = Props.setSearch;
  var highlightTrait = Props.highlightTrait;
  var exaltedUnits = Props.exaltedUnits;
  React.useState(function () {
        
      });
  var match = React.useState(function () {
        return "Units";
      });
  var setChoiceTab = match[1];
  var choiceTab = match[0];
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex md:hidden"
                }, React.createElement(Tabs, {
                      children: null,
                      value: choiceTab,
                      onChange: (function (param, v) {
                          return Curry._1(setChoiceTab, (function (param) {
                                        return v;
                                      }));
                        })
                    }, React.createElement(Tab, {
                          label: "Units",
                          value: "Units"
                        }), React.createElement(Tab, {
                          label: "Items",
                          value: "Items"
                        }))), React.createElement("div", {
                  className: "flex items-start"
                }, React.createElement(TbUnitSelection.make, {
                      choiceTab: choiceTab,
                      addUnit: addUnit,
                      setSearch: setSearch,
                      search: search,
                      highlightTrait: highlightTrait,
                      exaltedUnits: exaltedUnits
                    }), React.createElement(make, {
                      search: search,
                      choiceTab: choiceTab
                    })));
}

var UnitItemSelection = {
  make: TbPage46$UnitItemSelection
};

var leftUmbral = [
  0,
  10,
  20,
  31,
  32,
  33
];

var leftUmbral4 = [
  5,
  16,
  25
];

var rightUmbral = [
  5,
  16,
  25,
  33,
  34,
  35
];

var rightUmbral4 = [
  0,
  10,
  20
];

function getHighlight(gameCfg, hasUmbral4, rowNum, colNum) {
  var umbral = gameCfg.umbral;
  if (umbral === undefined) {
    return ;
  }
  var hex = Math.imul(rowNum, 10) + colNum | 0;
  if (umbral === 0) {
    if (leftUmbral.includes(hex) || hasUmbral4 && leftUmbral4.includes(hex)) {
      return "#" + Colors.indigo300;
    } else {
      return ;
    }
  } else if (rightUmbral.includes(Math.imul(rowNum, 10) + colNum | 0) || hasUmbral4 && rightUmbral4.includes(hex)) {
    return "#" + Colors.indigo300;
  } else {
    return ;
  }
}

function useMinion(topTraitCounts, botTraitCounts, topUnits, botUnits, units, augments, setUnits, addContents, unit, trait, traitBreakpoints, parentUnitId) {
  var topTraitCount = Belt_Option.map(Caml_option.undefined_to_opt(topTraitCounts.find(function (param) {
                return Caml_obj.caml_equal(param[0], trait);
              })), (function (prim) {
          return prim[1];
        }));
  var botTraitCount = Belt_Option.map(Caml_option.undefined_to_opt(botTraitCounts.find(function (param) {
                return Caml_obj.caml_equal(param[0], trait);
              })), (function (prim) {
          return prim[1];
        }));
  return RR.useIsoLayoutEffect2((function (param) {
                var topMinions = Belt_Array.keep(topUnits, (function (hc) {
                        var u = hc.unit;
                        var tmp;
                        tmp = u.TAG === /* Unit */0 ? false : u._0 === unit;
                        if (tmp) {
                          return true;
                        } else {
                          return Belt_Array.some(hc.items, (function (itemId) {
                                        return itemId === TbUtils46.Content.encodeStr({
                                                    TAG: /* Other */1,
                                                    _0: unit
                                                  });
                                      }));
                        }
                      })).length;
                var botMinions = Belt_Array.keep(botUnits, (function (hc) {
                        var u = hc.unit;
                        var tmp;
                        tmp = u.TAG === /* Unit */0 ? false : u._0 === unit;
                        if (tmp) {
                          return true;
                        } else {
                          return Belt_Array.some(hc.items, (function (itemId) {
                                        return itemId === TbUtils46.Content.encodeStr({
                                                    TAG: /* Other */1,
                                                    _0: unit
                                                  });
                                      }));
                        }
                      })).length;
                var tmp;
                if (topTraitCount !== undefined) {
                  var tc = Caml_option.valFromOption(topTraitCount);
                  tmp = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(traitBreakpoints.find(function (param) {
                                return Caml_obj.caml_greaterequal(tc, param[0]);
                              })), 0, (function (prim) {
                          return prim[1];
                        }));
                } else {
                  tmp = 0;
                }
                var topMinionTarget = tmp + (
                  parentUnitId !== undefined && Belt_Array.some(topUnits, (function (hc) {
                          var uid = hc.unit;
                          if (uid.TAG === /* Unit */0) {
                            return uid._0 === parentUnitId;
                          } else {
                            return false;
                          }
                        })) ? 1 : 0
                ) | 0;
                if (topMinionTarget > topMinions) {
                  Curry._2(addContents, {
                        TAG: /* Other */1,
                        _0: unit
                      }, true);
                } else if (topMinions > topMinionTarget) {
                  var toRemove = {
                    contents: topMinions - topMinionTarget | 0
                  };
                  Curry._1(setUnits, (function (units) {
                          return Belt_MapInt.keep(units, (function (key, u) {
                                        if (toRemove.contents === 0) {
                                          return true;
                                        }
                                        var rowNum = key % 10;
                                        var u$1 = u.unit;
                                        if (u$1.TAG === /* Unit */0 || !(u$1._0 === unit && rowNum > 3)) {
                                          return true;
                                        } else {
                                          toRemove.contents = toRemove.contents - 1 | 0;
                                          return false;
                                        }
                                      }));
                        }));
                }
                var tmp$1;
                if (botTraitCount !== undefined) {
                  var tc$1 = Caml_option.valFromOption(botTraitCount);
                  tmp$1 = Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(traitBreakpoints.find(function (param) {
                                return Caml_obj.caml_greaterequal(tc$1, param[0]);
                              })), 0, (function (prim) {
                          return prim[1];
                        }));
                } else {
                  tmp$1 = 0;
                }
                var botMinionTarget = tmp$1 + (
                  parentUnitId !== undefined && Belt_Array.some(botUnits, (function (hc) {
                          var uid = hc.unit;
                          if (uid.TAG === /* Unit */0) {
                            return uid._0 === parentUnitId;
                          } else {
                            return false;
                          }
                        })) ? 1 : 0
                ) | 0;
                if (botMinionTarget > botMinions) {
                  Curry._2(addContents, {
                        TAG: /* Other */1,
                        _0: unit
                      }, false);
                } else if (botMinions > botMinionTarget) {
                  var toRemove$1 = {
                    contents: botMinions - botMinionTarget | 0
                  };
                  Curry._1(setUnits, (function (units) {
                          return Belt_MapInt.map(Belt_MapInt.keep(units, (function (key, u) {
                                            if (toRemove$1.contents === 0) {
                                              return true;
                                            }
                                            var rowNum = key % 10;
                                            var u$1 = u.unit;
                                            if (u$1.TAG === /* Unit */0 || !(u$1._0 === unit && rowNum <= 3)) {
                                              return true;
                                            } else {
                                              toRemove$1.contents = toRemove$1.contents - 1 | 0;
                                              return false;
                                            }
                                          })), (function (u) {
                                        if (toRemove$1.contents === 0 || !Belt_Array.some(u.items, (function (itemId) {
                                                  return itemId === TbUtils46.Content.encodeStr({
                                                              TAG: /* Other */1,
                                                              _0: unit
                                                            });
                                                }))) {
                                          return u;
                                        } else {
                                          toRemove$1.contents = toRemove$1.contents - 1 | 0;
                                          return {
                                                  unit: u.unit,
                                                  items: Belt_Array.keep(u.items, (function (itemId) {
                                                          return itemId !== TbUtils46.Content.encodeStr({
                                                                      TAG: /* Other */1,
                                                                      _0: unit
                                                                    });
                                                        })),
                                                  starLevel: u.starLevel,
                                                  chosenTrait: u.chosenTrait
                                                };
                                        }
                                      }));
                        }));
                }
                
              }), [
              units,
              augments
            ]);
}

var openQs = (function (locale, qs) {
  window.open("https://u.tft.tools/screenshot/team-builder/" + (locale === "en" ? "" : locale + "/") + qs, "_blank")
});

function canAddItem(currItems, itemId) {
  var match = Belt_Array.partition(currItems, (function (itemId) {
          return !itemId.includes("TFT12_Yuumi");
        }));
  if (itemId.includes("TFT12_Yuumi")) {
    return match[1].length < 1;
  } else {
    return match[0].length < 3;
  }
}

function TbPage46(Props) {
  var onGoToSet6 = Props.onGoToSet6;
  var locale = Props.locale;
  var board = Props.board;
  var exalteds = Props.exalteds;
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return "";
      });
  var setSearch = match[1];
  var match$1 = React.useState(function () {
        
      });
  var setHighlightTrait = match$1[1];
  var highlightTrait = match$1[0];
  var traitsT = Translation.useT(/* Traits */2);
  var match$2 = Jotai.useAtom(TbAtoms.useSkins);
  var setUseSkins = match$2[1];
  var match$3 = Jotai.useAtom(TbAtoms.showNames);
  var setShowNames = match$3[1];
  var match$4 = Jotai.useAtom(TbAtoms.compactMode);
  var compactMode = match$4[0];
  var setUseSkins$1 = React.useCallback((function (v) {
          LocalStorage.set(TbAtoms.useSkinsKey, v);
          return Curry._1(setUseSkins, v);
        }), []);
  var setShowNames$1 = React.useCallback((function (v) {
          LocalStorage.set(TbAtoms.showNamesKey, v);
          return Curry._1(setShowNames, v);
        }), []);
  var xGridSize = 96;
  var yGridSize = 96;
  var match$5 = React.useMemo((function () {
          return TbUtils46.decodeQs(board);
        }), []);
  var initGameCfg = match$5[2];
  var initAugments = match$5[1];
  var initUnits = match$5[0];
  var match$6 = React.useState(function () {
        return initUnits;
      });
  var setUnits = match$6[1];
  var units = match$6[0];
  var match$7 = React.useState(function () {
        return initAugments;
      });
  var setAugments = match$7[1];
  var augments = match$7[0];
  var match$8 = React.useState(function () {
        return initGameCfg;
      });
  var gameCfg = match$8[0];
  var match$9 = React.useState(function () {
        return Belt_Array.some(Belt_Array.range(4, 7), (function (rowNum) {
                      return Belt_Array.some(Belt_Array.range(0, 6), (function (colNum) {
                                    return Belt_Option.isSome(Belt_MapInt.get(units, Math.imul(colNum, 10) + rowNum | 0));
                                  }));
                    }));
      });
  var extended = match$9[0];
  var insertContents = React.useCallback((function (col) {
          return function (row, contents) {
            return Curry._1(setUnits, (function (units) {
                          return Belt_MapInt.set(units, Math.imul(col, 10) + row | 0, {
                                      unit: contents,
                                      items: [],
                                      starLevel: 0,
                                      chosenTrait: 0
                                    });
                        }));
          };
        }), [setUnits]);
  var addContents = React.useCallback((function (contents) {
          return function (topBoard) {
            var tmp;
            tmp = contents.TAG === /* Unit */0 ? Math.max(1, Dict.getExn(Data.units(set), contents._0).stats.range) : 1;
            var range = Math.min(4, tmp);
            return Curry._1(setUnits, (function (units) {
                          var rows = topBoard ? Belt_Array.concat([3 + range | 0], Belt_Array.range(4, 7)) : Belt_Array.concat([4 - range | 0], Belt_Array.range(0, extended ? 7 : 3));
                          var emptySlot = Belt_Array.concatMany(Belt_Array.map(rows, (function (y) {
                                        return Belt_Array.map(Belt_Array.range(0, 6), (function (x) {
                                                      return [
                                                              x,
                                                              y
                                                            ];
                                                    }));
                                      }))).find(function (param) {
                                return Belt_Option.isNone(Belt_MapInt.get(units, Math.imul(param[0], 10) + param[1] | 0));
                              });
                          if (emptySlot !== undefined) {
                            return Belt_MapInt.set(units, Math.imul(emptySlot[0], 10) + emptySlot[1] | 0, {
                                        unit: contents,
                                        items: [],
                                        starLevel: 0,
                                        chosenTrait: 0
                                      });
                          } else {
                            return units;
                          }
                        }));
          };
        }), [setUnits]);
  var addUnit = React.useCallback((function (unit) {
          switch (unit) {
            case "TFT_BlueGolem" :
                return Curry._2(addContents, {
                            TAG: /* Other */1,
                            _0: /* Sentinel */1
                          }, false);
            case "TFT_TrainingDummy" :
                return Curry._2(addContents, {
                            TAG: /* Other */1,
                            _0: /* Dummy */2
                          }, false);
            default:
              return Curry._2(addContents, {
                          TAG: /* Unit */0,
                          _0: unit
                        }, false);
          }
        }), [addContents]);
  var encodedQs = React.useMemo((function () {
          if (units === undefined && augments.length === 0) {
            return ;
          } else {
            return TbUtils46.encodeQs(units, augments, gameCfg);
          }
        }), [
        units,
        augments,
        gameCfg
      ]);
  var onScreenshot = React.useCallback((function (param) {
          if (encodedQs !== undefined) {
            return openQs(locale, encodedQs);
          }
          var cb = SnackbarService.sub.contents;
          if (cb !== undefined) {
            return Curry._1(cb, "Can't screenshot empty board");
          }
          
        }), [encodedQs]);
  React.useEffect((function () {
          RescriptReactRouter.replace((
                locale === "en" ? "" : "/" + locale
              ) + Route.toString({
                    TAG: /* TeamPlanner */3,
                    _0: encodedQs
                  }));
          var newTitle = hexesToTitle(units, augments);
          if (newTitle !== "") {
            T.setPageTitle(newTitle);
          } else {
            T.setPageTitle("Team Builder - Tft Stats & Tools");
          }
          
        }), [
        encodedQs,
        units,
        augments
      ]);
  React.useEffect((function () {
          if (!extended) {
            Curry._1(setUnits, (function (units) {
                    var cells = Belt_Array.concatMany(Belt_Array.map(Belt_Array.range(4, 7), (function (rowNum) {
                                return Belt_Array.map(Belt_Array.range(0, 6), (function (colNum) {
                                              return [
                                                      colNum,
                                                      rowNum
                                                    ];
                                            }));
                              })));
                    return Belt_Array.reduce(cells, units, (function (acc, param) {
                                  return Belt_MapInt.remove(acc, Math.imul(param[0], 10) + param[1] | 0);
                                }));
                  }));
          }
          
        }), [extended]);
  var match$10 = ReactDnd.useDrop({
        accept: [
          "unit",
          "hex",
          "item",
          "hex-item"
        ],
        drop: (function (param) {
            
          })
      });
  var justDropped = React.useRef(false);
  var onDrop = function (colNum, rowNum, content) {
    var unitId = TbUtils46.Content.decodeStr(content);
    if (!justDropped.current) {
      justDropped.current = true;
      Curry._3(insertContents, colNum, rowNum, unitId);
      setTimeout((function (param) {
              justDropped.current = false;
              
            }), 50);
      return ;
    }
    
  };
  var onMove = function (from, to_) {
    if (justDropped.current) {
      return ;
    }
    justDropped.current = true;
    var fromCell = Belt_MapInt.get(units, Math.imul(from[0], 10) + from[1] | 0);
    var toCell = Belt_MapInt.get(units, Math.imul(to_[0], 10) + to_[1] | 0);
    Curry._1(setUnits, (function (units) {
            if (fromCell !== undefined) {
              if (toCell !== undefined) {
                return Belt_MapInt.set(Belt_MapInt.set(units, Math.imul(from[0], 10) + from[1] | 0, toCell), Math.imul(to_[0], 10) + to_[1] | 0, fromCell);
              } else {
                return Belt_MapInt.set(Belt_MapInt.remove(units, Math.imul(from[0], 10) + from[1] | 0), Math.imul(to_[0], 10) + to_[1] | 0, fromCell);
              }
            } else {
              return units;
            }
          }));
    setTimeout((function (param) {
            justDropped.current = false;
            
          }), 50);
    
  };
  var onDropItem = function (to_, itemId, _shadow) {
    var cell = Belt_MapInt.get(units, Math.imul(to_[0], 10) + to_[1] | 0);
    if (cell !== undefined && TbUtils46.Content.canHaveItems(cell.unit) && canAddItem(cell.items, itemId)) {
      return Curry._1(setUnits, (function (units) {
                    return Belt_MapInt.set(units, Math.imul(to_[0], 10) + to_[1] | 0, {
                                unit: cell.unit,
                                items: Belt_Array.concat(cell.items, [itemId]),
                                starLevel: cell.starLevel,
                                chosenTrait: cell.chosenTrait
                              });
                  }));
    }
    
  };
  var onMoveItem = function (from, to_, fromIdx) {
    var match = Belt_MapInt.get(units, Math.imul(from[0], 10) + from[1] | 0);
    var match$1 = Belt_MapInt.get(units, Math.imul(to_[0], 10) + to_[1] | 0);
    if (match === undefined) {
      return ;
    }
    if (match$1 === undefined) {
      return ;
    }
    if (!(Caml_obj.caml_notequal(from, to_) && TbUtils46.Content.canHaveItems(match$1.unit))) {
      return ;
    }
    var itemId = Belt_Array.get(match.items, fromIdx);
    if (itemId !== undefined && canAddItem(match$1.items, itemId)) {
      return Curry._1(setUnits, (function (units) {
                    return Belt_MapInt.set(Belt_MapInt.set(units, Math.imul(from[0], 10) + from[1] | 0, {
                                    unit: match.unit,
                                    items: Belt_Array.keepWithIndex(match.items, (function (param, idx) {
                                            return idx !== fromIdx;
                                          })),
                                    starLevel: match.starLevel,
                                    chosenTrait: match.chosenTrait
                                  }), Math.imul(to_[0], 10) + to_[1] | 0, {
                                unit: match$1.unit,
                                items: Belt_Array.concat(match$1.items, [Belt_Array.getExn(match.items, fromIdx)]),
                                starLevel: match$1.starLevel,
                                chosenTrait: match$1.chosenTrait
                              });
                  }));
    }
    
  };
  var onRemove = function (colNum, rowNum) {
    return Curry._1(setUnits, (function (units) {
                  var idx = Math.imul(colNum, 10) + rowNum | 0;
                  Belt_MapInt.get(units, idx);
                  Belt_MapInt.toArray(units);
                  return Belt_MapInt.remove(units, idx);
                }));
  };
  var onRemoveItem = function (colNum, rowNum, idx) {
    var cell = Belt_MapInt.get(units, Math.imul(colNum, 10) + rowNum | 0);
    if (cell !== undefined) {
      return Curry._1(setUnits, (function (units) {
                    return Belt_MapInt.set(units, Math.imul(colNum, 10) + rowNum | 0, {
                                unit: cell.unit,
                                items: Belt_Array.keepWithIndex(cell.items, (function (param, i) {
                                        return i !== idx;
                                      })),
                                starLevel: cell.starLevel,
                                chosenTrait: cell.chosenTrait
                              });
                  }));
    }
    
  };
  var onSetStarLevel = function (colNum, rowNum, starLevel) {
    var cell = Belt_MapInt.get(units, Math.imul(colNum, 10) + rowNum | 0);
    if (cell !== undefined) {
      return Curry._1(setUnits, (function (units) {
                    return Belt_MapInt.set(units, Math.imul(colNum, 10) + rowNum | 0, {
                                unit: cell.unit,
                                items: cell.items,
                                starLevel: starLevel,
                                chosenTrait: cell.chosenTrait
                              });
                  }));
    }
    
  };
  var onToggleMech = function (colNum, rowNum, chosenTraitIdx) {
    var cell = Belt_MapInt.get(units, Math.imul(colNum, 10) + rowNum | 0);
    if (cell !== undefined) {
      return Curry._1(setUnits, (function (units) {
                    var key = Math.imul(colNum, 10) + rowNum | 0;
                    return Belt_MapInt.mapWithKey(units, (function (k, cell) {
                                  if (key === k) {
                                    return {
                                            unit: cell.unit,
                                            items: cell.items,
                                            starLevel: cell.starLevel,
                                            chosenTrait: cell.chosenTrait === chosenTraitIdx ? 0 : chosenTraitIdx
                                          };
                                  } else if (cell.chosenTrait !== 0) {
                                    return {
                                            unit: cell.unit,
                                            items: cell.items,
                                            starLevel: cell.starLevel,
                                            chosenTrait: 0
                                          };
                                  } else {
                                    return cell;
                                  }
                                }));
                  }));
    }
    
  };
  var idx = gameCfg.exalted;
  var exaltedUnits = idx !== undefined ? Belt_Array.getExn(exalteds, idx) : [];
  var match$11 = TbUtils46.getData(units, false, augments, exaltedUnits);
  var botChosenTrait = match$11[3];
  var botItems = match$11[2];
  var botTraitCounts = match$11[1];
  var match$12 = TbUtils46.getData(units, true, [], exaltedUnits);
  var topChosenTrait = match$12[3];
  var topTraitCounts = match$12[1];
  var hasUmbral4 = Belt_Array.some(botTraitCounts, (function (param) {
          if (param[0] === "TFT11_Umbral") {
            return param[1] >= 4;
          } else {
            return false;
          }
        }));
  var topUnits2 = Belt_Array.keepMap(match$12[0], (function (u) {
          var unitId = u.unit;
          if (unitId.TAG === /* Unit */0) {
            return [
                    unitId._0,
                    u.starLevel
                  ];
          }
          
        }));
  var botUnits2 = Belt_Array.keepMap(match$11[0], (function (u) {
          var unitId = u.unit;
          if (unitId.TAG === /* Unit */0) {
            return [
                    unitId._0,
                    u.starLevel
                  ];
          }
          
        }));
  var grayscaleCoords = [];
  var tmp;
  if (extended) {
    var tmp$1 = {
      units: topUnits2,
      traitCounts: topTraitCounts
    };
    if (topChosenTrait !== undefined) {
      tmp$1.chosenTrait = Caml_option.valFromOption(topChosenTrait);
    }
    tmp = React.createElement(TbTraitsListCompact.make, tmp$1);
  } else {
    tmp = null;
  }
  var tmp$2 = {
    units: botUnits2,
    traitCounts: botTraitCounts,
    padTop: extended
  };
  if (botChosenTrait !== undefined) {
    tmp$2.chosenTrait = Caml_option.valFromOption(botChosenTrait);
  }
  var tmp$3 = {
    className: "w-full md:w-auto flex"
  };
  var tmp$4 = augments.length !== 0 ? "team-builder-main" : undefined;
  if (tmp$4 !== undefined) {
    tmp$3.id = Caml_option.valFromOption(tmp$4);
  }
  var tmp$5 = {
    className: "w-full md:w-auto flex"
  };
  var tmp$6 = augments.length === 0 ? "team-builder-main" : undefined;
  if (tmp$6 !== undefined) {
    tmp$5.id = Caml_option.valFromOption(tmp$6);
  }
  var tmp$7;
  if (extended) {
    var tmp$8 = {
      setHighlightTrait: setHighlightTrait,
      units: topUnits2,
      traitCounts: topTraitCounts,
      onFilterTrait: (function (t) {
          return Curry._1(setSearch, (function (param) {
                        return traitsT(t);
                      }));
        }),
      items: match$12[2],
      augments: augments,
      setAugments: setAugments,
      exaltedUnits: exaltedUnits
    };
    if (topChosenTrait !== undefined) {
      tmp$8.chosenTrait = Caml_option.valFromOption(topChosenTrait);
    }
    tmp$7 = React.createElement(TbPage46$TraitsListWrap, tmp$8);
  } else {
    tmp$7 = null;
  }
  var tmp$9 = {
    setHighlightTrait: setHighlightTrait,
    units: botUnits2,
    traitCounts: botTraitCounts,
    onFilterTrait: (function (t) {
        return Curry._1(setSearch, (function (param) {
                      return traitsT(t);
                    }));
      }),
    items: botItems,
    augments: augments,
    setAugments: setAugments,
    exaltedUnits: exaltedUnits
  };
  if (botChosenTrait !== undefined) {
    tmp$9.chosenTrait = Caml_option.valFromOption(botChosenTrait);
  }
  return React.createElement("div", {
              className: "flex flex-col items-center w-screen md:w-auto"
            }, React.createElement(DragPreview46.make, {
                  exaltedUnits: exaltedUnits
                }), React.createElement("div", {
                  className: "pb-6 w-full sm:w-auto"
                }, React.createElement(TbConfig46.make, {
                      locale: locale,
                      extended: extended,
                      setExpanded: match$9[1],
                      units: units,
                      setUnits: setUnits,
                      useSkins: match$2[0],
                      setUseSkins: setUseSkins$1,
                      showNames: match$3[0],
                      setShowNames: setShowNames$1,
                      onGoToSet6: onGoToSet6,
                      augments: augments,
                      onScreenshot: onScreenshot,
                      gameCfg: gameCfg
                    })), React.createElement("div", {
                  className: "block md:hidden mt-6 md:mt-0 w-full"
                }, tmp, React.createElement(TbTraitsListCompact.make, tmp$2)), React.createElement("div", {
                  className: "flex w-full md:w-auto items-start mb-6"
                }, React.createElement("div", tmp$3, React.createElement("div", tmp$5, React.createElement("div", {
                              className: CssJs.merge([
                                    "pr-4 lg:pr-6 hidden md:grid gap-8",
                                    CssJs.style([
                                          T.md_([
                                                CssJs.gridTemplateRows(extended ? [
                                                        CssJs.fr(1),
                                                        CssJs.fr(1)
                                                      ] : [CssJs.fr(1)]),
                                                CssJs.height(CssJs.px(extended ? (
                                                            compactMode ? TbConsts.heightMdFullCompact : TbConsts.heightMdFull
                                                          ) : (
                                                            compactMode ? TbConsts.heightMdCompact : TbConsts.heightMd
                                                          )))
                                              ]),
                                          T.xl_([CssJs.height(CssJs.px(extended ? (
                                                            compactMode ? TbConsts.heightXlFullCompact : TbConsts.heightXlFull
                                                          ) : (
                                                            compactMode ? TbConsts.heightXlCompact : TbConsts.heightXl
                                                          )))])
                                        ])
                                  ])
                            }, tmp$7, React.createElement(TbPage46$TraitsListWrap, tmp$9)), React.createElement(ContentSection.make, {
                              className: "w-full md:w-auto p-0 relative",
                              children: React.createElement("svg", {
                                    ref: match$10[1],
                                    className: CssJs.merge([
                                          "select-none w-full md:w-[684px] xl:w-[760px]",
                                          CssJs.style([CssJs.unsafe("aspectRatio", extended ? (
                                                        compactMode ? "760/" + String(TbConsts.heightXlFullCompact) : "760/" + String(TbConsts.heightXlFull)
                                                      ) : (
                                                        compactMode ? "760/" + String(TbConsts.heightXlCompact) : "760/" + String(TbConsts.heightXl)
                                                      ))])
                                        ]),
                                    id: "team-planner-svg",
                                    viewBox: TbConsts.viewBox(compactMode, extended)
                                  }, React.createElement(TbDefs.make, {}), React.createElement("g", {
                                        transform: "translate(22, 14)"
                                      }, extended ? React.createElement(TbTeamsSeparator.make, {
                                              hexSize: 50,
                                              xGridSize: xGridSize,
                                              compactMode: compactMode
                                            }) : null, Belt_Array.map(Belt_Array.range(0, extended ? 7 : 3), (function (rowNum) {
                                              return Belt_Array.map(Belt_Array.range(0, 6), (function (colNum) {
                                                            var hex = Belt_MapInt.get(units, Math.imul(colNum, 10) + rowNum | 0);
                                                            var grayscale = grayscaleCoords.includes(Math.imul(colNum, 10) + rowNum | 0);
                                                            var highlight = getHighlight(gameCfg, hasUmbral4, rowNum, colNum);
                                                            var tmp = {
                                                              highlightTrait: highlightTrait,
                                                              hexSize: 50,
                                                              xGridSize: xGridSize,
                                                              yGridSize: yGridSize,
                                                              extended: extended,
                                                              colNum: colNum,
                                                              rowNum: rowNum,
                                                              onDrop: onDrop,
                                                              onMove: onMove,
                                                              onDropItem: onDropItem,
                                                              onMoveItem: onMoveItem,
                                                              onRemove: onRemove,
                                                              onRemoveItem: onRemoveItem,
                                                              onSetStarLevel: onSetStarLevel,
                                                              onToggleMech: onToggleMech,
                                                              traitCounts: rowNum <= 3 ? botTraitCounts : topTraitCounts,
                                                              grayscale: grayscale,
                                                              exaltedUnits: exaltedUnits,
                                                              key: String(Math.imul(colNum, 10) + rowNum | 0)
                                                            };
                                                            if (hex !== undefined) {
                                                              tmp.hex = Caml_option.valFromOption(hex);
                                                            }
                                                            if (highlight !== undefined) {
                                                              tmp.highlight = Caml_option.valFromOption(highlight);
                                                            }
                                                            return React.createElement(TeamPlannerHex46.make, tmp);
                                                          }));
                                            }))), React.createElement(TbBranding.make, {}))
                            })), React.createElement("div", {
                          className: "hidden xl:flex flex-col ml-6 w-[124px]"
                        }, React.createElement(TbAugmentSelection46.make, {
                              augments: augments,
                              setAugments: setAugments
                            }), React.createElement(TbComponentsSection46.make, {
                              items: botItems,
                              augments: augments,
                              setAugments: setAugments
                            })))), React.createElement(TbPage46$UnitItemSelection, {
                  addUnit: addUnit,
                  search: match[0],
                  setSearch: setSearch,
                  highlightTrait: highlightTrait,
                  exaltedUnits: exaltedUnits
                }));
}

var make$1 = TbPage46;

export {
  ItemsGrid ,
  TraitsListWrap ,
  hexesToTitle ,
  qsToTitle ,
  UnitItemSelection ,
  leftUmbral ,
  leftUmbral4 ,
  rightUmbral ,
  rightUmbral4 ,
  getHighlight ,
  useMinion ,
  openQs ,
  canAddItem ,
  make$1 as make,
  
}
/* make Not a pure module */
